import axios from "axios";
import store from './../index'

// «Аналитика → Клиенты и комплекты» (ClientsComplectsReport/*): привязки комплектов к логинам аптек и дистрибьюторов.

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // Справочники фильтров: комплекты, города, менеджеры, типы клиента, статусы договора
    CLIENTS_COMPLECTS_FILTER_OPTIONS: async () => {
      const { data } = await axios.get('/ClientsComplectsReport/GetFilterOptionsAsync');

      return data;
    },

    CLIENTS_COMPLECTS_REPORT: async (_, search) => {
      const { data } = await axios.post('/ClientsComplectsReport/GetReportAsync', search || {});

      return data;
    },

    // Страница отчёта: { search, pageNumber, pageSize } — страница = pageSize компаний (групп), счётчики по всему фильтру
    CLIENTS_COMPLECTS_REPORT_PAGED: async (_, request) => {
      const { data } = await axios.post('/ClientsComplectsReport/GetReportPagedAsync', request || {});

      return data;
    },

    DOWNLOAD_CLIENTS_COMPLECTS_REPORT: async (_, search) => {
      try {
        const { data } = await axios.post('/ClientsComplectsReport/DownloadAsync', search || {}, {
          responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'ClientsComplects.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        return true;
      } catch (error) {
        // Ответ запрошен как blob, поэтому текст ошибки (400, { error }) читаем из него
        let text = 'Не удалось сформировать отчёт';
        try {
          const body = error.response?.data;
          if (body instanceof Blob) {
            text = JSON.parse(await body.text()).error || text;
          } else if (body?.error) {
            text = body.error;
          }
        } catch (parseError) {
          window.console.log(parseError);
        }
        store.commit('SET_SNACKBAR', {
          text,
          timeout: 7500,
          color: 'error',
          linkText: '',
          show: true,
        });
        throw error;
      }
    },
  }
};
